import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import { ImagePicker } from '../../../component/imagePicker';
import { Input } from '../../../component/input';
import { AddModal } from '../../../component/modal';
import { useEditLifestyleCategoriesMutation } from '../../../store/lifeStyle/api';
import { ILifeStyle } from '../../../store/lifeStyle/interface';
import { useEditStoreCategoriesMutation } from '../../../store/shopping/api';
import { IStoreCategory } from '../../../store/shopping/interface';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { editCategoryValidation } from '../validation';

type IEditCategory = {
  show?: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  currentTab: string;
  categoryDetails: ILifeStyle | IStoreCategory | undefined;
};
type FormikValues = {
  name: string;
  file: File[] | null;
};
export const EditCategory: FC<IEditCategory> = ({
  setShow,
  currentTab,
  categoryDetails
}) => {
  const [editShoppingCategory, { isLoading: isEditShoppingLoading }] =
    useEditStoreCategoriesMutation();
  const [editLifestyleCategory, { isLoading: isLifestyleEditing }] =
    useEditLifestyleCategoriesMutation();

  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file);
  };
  const handleEditCategory = (values: FormikValues) => {
    if (currentTab === 'Shopping') {
      if (!values.file) return showErrorToast('category picture is required');
      const payload = new FormData();
      payload.append('name', values.name);
      values.file.forEach((file) => {
        payload.append('file', file);
      });
      // edit lifestyle still pending
      editShoppingCategory({ body: payload, id: categoryDetails?._id ?? '' })
        .unwrap()
        .then((res) => {
          showSuccessToast(res.message);
          setShow(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    } else if (currentTab === 'Lifestyle') {
      const payload = new FormData();
      if (values.name !== (categoryDetails as ILifeStyle).title) {
        payload.append('title', values.name);
      }
      if (values.file) {
        values.file.forEach((file) => {
          payload.append('file', file);
        });
      }
      editLifestyleCategory({ body: payload, id: categoryDetails?._id ?? '' })
        .unwrap()
        .then((res) => {
          showSuccessToast(res.message);
          setShow(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    }
  };
  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        name: (categoryDetails as ILifeStyle).title,
        file: null
      },
      validationSchema: editCategoryValidation,
      onSubmit: handleEditCategory
    });

  return (
    <AddModal
      title={`Edit ${currentTab} Category`}
      disableBtn={isEditShoppingLoading || isLifestyleEditing}
      btnTxt={'Edit category'}
      isLoading={isEditShoppingLoading}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
    >
      <Container>
        <CustomInput
          labelText={'Category title'}
          value={values.name}
          onChange={handleChange('name')}
          errorMessage={touched.name ? errors.name : ''}
        />

        <CustomImageUpload onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;
  padding-bottom: 32px;
`;

const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
